import React from 'react';
import { map } from 'lodash';

import { recipeOptions } from '../api/dummyData';
import { getInitialIngredients } from '../utilities/content/getInitialIngredients';
import { labels } from '../configuration/labels';

const RecipeList = ({ setSelectedRecipe, onRecipeChange }) => {
  function handleRecipeChange(recipeName) {
    setSelectedRecipe(recipeName);
    onRecipeChange(getInitialIngredients(recipeName));
  }

  return (
    <div className="recipe-list">
      <h3>{labels.recipeSelectHeader}</h3>
      <div className="recipe-list-content">
        {map(recipeOptions, (recipeOption) => (
          <button
            key={recipeOption}
            className="btn btn-recipe"
            onClick={() => handleRecipeChange(recipeOption)}
          >
            {recipeOption}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RecipeList;
